import React from 'react'
import {useSelector,useDispatch} from 'react-redux'

import Header from '../map/components/Header'
import PopupDefault from '../map/components/popups/PopupDefault'

import MemberHeader from './parts/MemberHeader'
import MemberFooter from './parts/MemberFooter'

const AllMembers = () => {
  const setApp = useDispatch();
  const {first_name,last_name} = useSelector(s=>s.auth);

  const allUsers = window.pagedata.all_users;

  return (
    <>
      <Header/>
      <PopupDefault/>

      <section id="member-area">

        <MemberHeader title="All Users"/>

        <div id="breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <div className="breadcrumb-items">
                    <ul id="breadcrumbs" className="breadcrumbs">
                      <li><a className="bread-link bread-home" href="/" title="Home">Home/Map</a></li>
                      <li><a className="bread-link" href="/member" title="Dashboard">Dashboard</a></li>
                      <li><strong className="bread-current">All users</strong></li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="member-block-style">
          <div className="container">
            <div className="row">
              <div className="col">
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col">
                <table className="table table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col" style={{width:24,textAlign:'center'}}><i className="fa fa-user-circle"/></th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Affiliation</th>
                      <th scope="col">Role</th>
                      <th scope="col" className="text-center" style={{width:88}}>Verified?</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      allUsers.map((d,i)=>{
                        const role = JSON.parse(d.roles)
                        return (
                          <tr key={d.id}>
                            <td>
                              <a href={`/member/account/${d.id}`}>
                                {
                                  d.photo ? (
                                    <img src={`/photo/${d.photo}`} style={{width:24,height:24,borderRadius:'100%'}}/>
                                  ) : <i style={{fontSize:24}} className="fa fa-user-circle"/>
                                }
                              </a>
                            </td>
                            <td>
                              <a href={`/member/account/${d.id}`}>
                                <b>{`${d.first_name} ${d.last_name}`}</b>
                              </a>
                            </td>
                            <td>{d.email}</td>
                            <td>{d.affiliation}</td>
                            <td>{role[0] === "ROLE_ADMIN" ? 'Administrator' : (role[0] === "ROLE_EDITOR" ? 'Data editor' : (role[0] === "ROLE_CONTRIBUTOR" ? 'Data contributor' : 'Public user'))}</td>
                            <td className="text-center">{d.is_verified ? <i className="text-success fa fa-check-circle"/> : <i className="text-warning fa fa-minus-circle"/>}</td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <MemberFooter/>

      </section>

    </>
  )
}

export default AllMembers
